import { useMemo } from 'react';

import type { TFunction } from 'i18next';
import type { InspectionTemplate } from 'inspection-types';
import { simpleDate } from 'lane-shared/helpers/formatters';

import { countSectionsAndQuestions } from '../../helpers/inspectionTemplateCustomizeHelpers';

export type InspectionTemplateCustomizeLabels = {
  summary: string | null;
  lastUpdatedText: string;
  saveDisabledTitle: string;
  revertAllDisabledTitle: string;
  /** Tooltip when section remove is unavailable (empty when remove is allowed). */
  removeSectionDisabledTitle: string;
  removeItemDisabledTitle: string;
};

export function useInspectionTemplateCustomizeLabels(
  template: InspectionTemplate | undefined,
  t: TFunction
): InspectionTemplateCustomizeLabels {
  return useMemo(() => {
    let summary: string | null = null;

    if (template) {
      const { sections, questions } = countSectionsAndQuestions(template);

      summary = t('web.admin.inspections.templateCustomize.questionsSummary', {
        sections,
        questions,
      });
    }

    const lastUpdatedRaw = template?.metadata.updatedAt;
    const lastUpdatedText = !lastUpdatedRaw
      ? t('punctuation.dash')
      : simpleDate(lastUpdatedRaw);

    return {
      summary,
      lastUpdatedText,
      saveDisabledTitle: t(
        'web.admin.inspections.templateCustomize.saveDisabledHint'
      ),
      revertAllDisabledTitle: t(
        'web.admin.inspections.templateCustomize.revertAllDisabledHint'
      ),
      removeSectionDisabledTitle: '',
      removeItemDisabledTitle: t(
        'web.admin.inspections.templateCustomize.removeItemDisabledHint'
      ),
    };
  }, [template, t]);
}
